export const TABLE_COLUMN_WIDTHS = {
  editTalbe: {
    active: "14%",
    image: "11%",
    name: "33%",
    price: "14%",
    stock: "14%",
    edit: "11%",
    delete: "11%",
  },
};
